module.exports = __webpack_public_path__ + "static/quiniela-f97a2cca4908d4d910529a3f77829469.svg";